module.exports = __webpack_public_path__ + "img/exclamation_grey_border.ddcb59db.svg";